import s from 'pages/common.module.scss'
import { MdSettings } from 'react-icons/md'
import useBienAVendre from 'hooks/useBienAVendre'
import { getTooltip, Tooltip } from 'utils/tooltipLibrary'
import { showCalculator } from 'redux/features/bienAVendre/slice'
import { useAppDispatch } from 'redux/hooks'

import Label from 'components/Label'
import NombreEtage from 'components/NombreEtage/NombreEtage'
import HouseFaceV2 from './components/HouseFaceV2/HouseFaceV2'

const EtageCalculator = (): JSX.Element | null => {
  const dispatch = useAppDispatch()
  const { etages, incrementNombreEtage, decrementNombreEtage } =
    useBienAVendre()

  const handleEtageEditeur = () => {
    dispatch(showCalculator(true))
  }

  return (
    <>
      <div>
        <Label
          label="Nombres d'étages : "
          tooltip={getTooltip(Tooltip.NombreEtage)}
          classes={s.tooltipSublevel}
        />

        <NombreEtage
          value={etages.length}
          onPlusClick={decrementNombreEtage}
          onMinusClick={incrementNombreEtage}
          min={0}
        />
        <button
          className={s.ouvertureEtageConfigurateur}
          type="button"
          onClick={() => handleEtageEditeur()}
        >
          <span>Configurer les étages </span>
          <MdSettings />
        </button>
      </div>
      <HouseFaceV2 />
    </>
  )
}

export default EtageCalculator
